import Video from "./Video";
import Popup from "./Popup";
import EndScreen from "./EndScreen";
import Branding from "./Branding";

function Player({ classes = "", attributes }) {
  const {
    provider,
    preload,
    popup,
    overlay,
    source,
    poster,
    protected: bProtected,
    protectedText,
    width,
    radius,
    endscreen,
    endscreenText,
    endscreenTextLink,
    popupType,
    popupBtnStyle,
    popupBtnText,
    popupBtnExists,
  } = attributes;
  // classes += popup && " h5vp_popup_wrapper popup_close";
  const playerWidth = width.number === 0 ? "100%" : width.number + width.unit;
  const playerRound = radius.number + radius.unit;
  return (
    <div className={classes} data-settings={JSON.stringify({})} style={{ width: playerWidth, borderRadius: playerRound, overflow: "hidden" }}>
      {popup && popupType === "button" && !popupBtnExists && (
        <div className="popupBtn">
          <button style={{ ...popupBtnStyle, padding: "0.4em 1.2em" }}>{popupBtnText}</button>
        </div>
      )}
      <div className="sticky_close">&times;</div>
      <div className="popup_close_btn">&times;</div>
      {/* {popup && <Popup poster={poster} />} */}
      {endscreen && <EndScreen buttonText={"Watch Again"} text={endscreenText} link={endscreenTextLink} />}
      {overlay && <Branding attributes={attributes} />}
      <div className="videoWrapper">
        <Video attributes={attributes} />
      </div>
    </div>
  );
}

export default Player;
